import React, { createContext, useContext, useState } from "react";

const DocumentContext = createContext();

export const DocumentInfoProvider = ({ children }) => {

  const [savingData, setSavingData] = useState({
    isSaving: '',
    lastSavedDateTime: "",
    fileSize: 0,
  });
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [isExternal, setIsExternal] = useState(false);
  const [isExternalAllow, setIsExternalAllow] = useState(false);
  const [documentInfo, setDocumentInfo] = useState({});
  const [userInfo, setUserInfo] = useState({});

  return (
    <DocumentContext.Provider
      value={{
        savingData, setSavingData,
        isReadOnly, setIsReadOnly,
        isExternal, setIsExternal,
        isExternalAllow, setIsExternalAllow,
        documentInfo, setDocumentInfo,
        userInfo, setUserInfo
      }}>
      {children}
    </DocumentContext.Provider>
  );
};

export const useDocument = () => {
  return useContext(DocumentContext);
};
